import { BasePricing } from "./base.mjs";
//#region src/workflowGen.ts
var PrepaidWorkflowGen = class extends BasePricing {
	getFinalPrice() {
		this.meter.addResult(this.calcWorkflowFixedPrice());
		return this.meter;
	}
	calcWorkflowFixedPrice() {
		const { workflowName } = this.parameters;
		const { workflowPrepaidPrice } = this.config;
		const [workflowNameOnly] = workflowName.split(":");
		const price = workflowPrepaidPrice[workflowNameOnly];
		return {
			cumulative: (i) => i + price,
			item: {
				key: "workflow-prepaid-fixed",
				name: "workflow prepaid fixed"
			}
		};
	}
};
//#endregion
export { PrepaidWorkflowGen };
